export const VIDEOS_AND_FIRST_FRAME_FOLDER = 143633;
export const USER_MANUAL_FOLDER = 178314;
export const PODCAST_URL_STORY = 158225007;

// used for injecting package data into components
export const PACKAGE_DATA = 'packageData';
export const ACCESSORY_TYPE = 'FcAccessory';
export const PACKAGE_TYPE = 'FcPackage';
export const BUNDLE_TYPE = 'FcBundle';
